// src/pages/Info/TosScreen.jsx

import React from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

const TosScreen = () => {
  return (
    <div sx={{ flexGrow: 1, padding: 3 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <div class="container">
            <h1>Terms and Conditions for Madecare</h1>

            <div class="section">
              <h2>1. Introduction</h2>
              <p>
                Madecare is a digital quiz game designed for educational and
                entertainment purposes. By using our app, you agree to abide by
                these terms and conditions, our privacy policy, and any other
                guidelines or rules provided to you within the app.
              </p>
            </div>

            <div class="section">
              <h2>2. Digital Coins</h2>
              <div class="subsection">
                <h3>Nature of Coins</h3>
                <p>
                  Madecare uses digital coins (hereafter referred to as
                  "Coins") as a virtual currency within the app. These Coins
                  hold no monetary value and cannot be exchanged for real
                  currency, goods, or services outside the app ecosystem.
                </p>
              </div>
              <div class="subsection">
                <h3>Withdrawal</h3>
                <p>
                  Users may accumulate Coins through gameplay and various
                  achievements within the app. While you can withdraw Coins,
                  please note that their value is not fixed and is solely
                  determined within the app environment.
                </p>
              </div>
              <div class="subsection">
                <h3>No Real-World Value</h3>
                <p>
                  Coins have no intrinsic value outside Madecare and are
                  intended solely for use within the app for in-game benefits
                  and rewards.
                </p>
              </div>
            </div>

            <div class="section">
              <h2>3. Return Policy</h2>
              <div class="subsection">
                <h3>Refunds</h3>
                <p>
                  Users may request a refund for purchases made within BOOK MY
                  DR within a period of two (2) days from the date of purchase.
                  Refund requests must be made through the app's support
                  channels and are subject to review based on our refund policy.
                </p>
              </div>
              <div class="subsection">
                <h3>Digital Goods</h3>
                <p>
                  Refunds apply to digital goods purchased within the app, such
                  as premium features or virtual items. Once a refund is
                  processed, any associated digital goods or benefits will be
                  revoked from your account.
                </p>
              </div>
            </div>

            <div class="section">
              <h2>4. User Responsibilities</h2>
              <div class="subsection">
                <h3>Account Security</h3>
                <p>
                  You are responsible for maintaining the confidentiality of
                  your account credentials and ensuring that unauthorized access
                  to your account does not occur.
                </p>
              </div>
              <div class="subsection">
                <h3>Prohibited Activities</h3>
                <p>
                  Use of Madecare for any unlawful purpose, including but not
                  limited to fraud, hacking, or dissemination of harmful
                  content, is strictly prohibited. Violation of these terms may
                  result in immediate termination of your account.
                </p>
              </div>
            </div>

            <div class="section">
              <h2>5. Modifications and Updates</h2>
              <div class="subsection">
                <h3>Changes to Terms</h3>
                <p>
                  Madecare reserves the right to modify or update these terms
                  and conditions at any time. Users will be notified of
                  significant changes through the app or via registered email.
                </p>
              </div>
              <div class="subsection">
                <h3>Continued Use</h3>
                <p>
                  Your continued use of Madecare following changes to these
                  terms constitutes acceptance of the modified terms and
                  conditions.
                </p>
              </div>
            </div>

            <div class="section">
              <h2>6. Limitation of Liability</h2>
              <div class="subsection">
                <h3>Disclaimer</h3>
                <p>
                  Madecare is provided "as is" without warranties of any kind,
                  whether express or implied. We do not guarantee uninterrupted
                  or error-free operation of the app, nor do we warrant the
                  accuracy, completeness, or reliability of any information
                  obtained through Madecare.
                </p>
              </div>
              <div class="subsection">
                <h3>Indemnification</h3>
                <p>
                  By using Madecare, you agree to indemnify and hold harmless
                  GK Money, its affiliates, officers, directors, and employees
                  from any claims, damages, or losses arising from your use of
                  the app or breach of these terms.
                </p>
              </div>
            </div>

            <div class="section">
              <h2>7. Contact Us</h2>
              <p>
                If you have any questions or concerns regarding these terms and
                conditions, please contact us at{" "}
                <span class="italic">support@gkmoney.com</span>. We are here to
                assist you and ensure your experience with Madecare is
                enjoyable and compliant with these guidelines.
              </p>
            </div>

            <div class="section">
              <h2>Conclusion</h2>
              <p>
                Thank you for choosing Madecare! We are committed to providing
                you with a safe, educational, and entertaining quiz game
                experience. By using Madecare, you acknowledge and agree to
                these terms and conditions. Have fun, challenge yourself, and
                explore the world of knowledge with Madecare!
              </p>
            </div>
          </div>
        </Grid>
      </Grid>
    </div>
  );
};

export default TosScreen;
